// extracted by mini-css-extract-plugin
export default {"CardContainer":"QuizInstructions_CardContainer__vWECu"};